import { ReactNode } from "react";
import cn from "classnames";

import { Heading as CommonHeading, HeadingProps as CommonHeadingProps } from "capitalrx-components-2.0/lib/typography";

import styles from "./styles.module.scss";
interface HeadingProps extends CommonHeadingProps {
  children: ReactNode;
}

export const Heading = (props: HeadingProps) => {
  const { children, className } = props;

  const headingClass = cn(
    styles["Heading"],
    className,
  );

  return (
    <CommonHeading {...props} className={headingClass}>
      {children}
    </CommonHeading>
  );
};
